import { render, staticRenderFns } from "./ListFormPage.vue?vue&type=template&id=6dc0e42b"
import script from "./ListFormPage.vue?vue&type=script&lang=js"
export * from "./ListFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports